import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 47 47"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("circle", {
        cx: "23.5",
        cy: "23.5",
        r: "23.5",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        fill: "#FFF",
        d: "M29 32H11.5C9.567 32 8 30.465 8 28.571V16h17.5c1.933 0 3.5 1.535 3.5 3.429zM39 32l-7-4.571V20.57L39 16z"
      })
    ], -1)
  ])))
}
export default { render: render }